module.exports = __webpack_public_path__ + "818617c90e01fcc9dd2ad69f02f814e8.jpg";